"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Label_component_exports = {};
__export(Label_component_exports, {
  Label: () => Label
});
module.exports = __toCommonJS(Label_component_exports);
var import_jsx_runtime = require("react/jsx-runtime");
var import_react = require("react");
var import_label = require("@react-aria/label");
var import_clsx = __toESM(require("clsx"));
const Label = (0, import_react.forwardRef)(
  (_a, ref) => {
    var _b = _a, {
      label,
      labelProps,
      validationError,
      dataTestId,
      className,
      children,
      htmlFor,
      id,
      isInvalid
    } = _b, props = __objRest(_b, [
      "label",
      "labelProps",
      "validationError",
      "dataTestId",
      "className",
      "children",
      "htmlFor",
      "id",
      "isInvalid"
    ]);
    let { labelProps: ariaLabelProps } = (0, import_label.useLabel)(__spreadProps(__spreadValues({}, labelProps), { label }));
    const labelStyle = (0, import_clsx.default)([`${validationError ? "text-[#A50D0D]" : ""}`, className]);
    return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(
      "label",
      __spreadProps(__spreadValues(__spreadProps(__spreadValues({
        className: labelStyle
      }, ariaLabelProps), {
        "data-testid": dataTestId,
        htmlFor,
        id,
        ref
      }), props), {
        children: [
          label,
          children
        ]
      })
    );
  }
);
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  Label
});
//# sourceMappingURL=Label.component.js.map